<!--suppress ALL -->
<template>
  <div class="navigation-bar-wrapper">
    <g-modal :active.sync="modalPassword" class="modal-default modal-input-password">
      <div class="box">
        <div class="head">
          <p class="subtitle is-5">Ubah password user</p>
        </div>
        <div class="content-selected">

          <g-field :label="`Password Baru`">
            <g-input v-model="newPassword" input-type="password">
              <i slot="iconLeft" class="fas fa-lock"></i>
            </g-input>
          </g-field>

          <g-field :label="`Konfirmasi Password`">
            <g-input v-model="confirmPassword" input-type="password">
              <i slot="iconLeft" class="fas fa-lock"></i>
            </g-input>
          </g-field>

          <g-field is-grouped position="right" style="margin-top: 2rem">
            <div class="control">
              <g-button type="info"
                        @click="modalPassword=false">
                {{ $t("button.close") }}
              </g-button>
            </div>
            <div class="control">
              <g-button @click="doChangePassword"
                        :value="`Simpan`" :type="'success'" />
            </div>
          </g-field>
        </div>
      </div>
    </g-modal>

    <nav class="navbar navbar-main">
      <div class="container is-widescreen">
        <div class="navbar-brand">
          <a @click="onToggleFullScreen" class="navbar-item">
            <span class="icon"><i class="fas fa-expand-alt"></i></span>
          </a>
          <a class="navbar-item">
            <div class="nb-i-wrp">
              <img :src="`/static/images/logo.png`" alt="KHAS Kempek Cirebon">
              <div class="detail">
                <p class="title is-6">KHAS Kempek Cirebon</p>
                <p class="text-mute">{{ user.profile }}</p>
              </div>
            </div>
          </a>
          <a @click="() => isMenuActive = !isMenuActive" aria-expanded="false"
             aria-label="menu" class="navbar-burger burger"
             data-target="navbarMainMenu" role="button">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
        <div :class="{'is-active': isMenuActive}" class="navbar-menu" id="navbarMainMenu">
          <div class="navbar-end">
            <div class="navbar-item">
              <div class="dropdown is-hoverable is-right">
                <div class="dropdown-trigger">
                  <a class="button is-white">
                    <lazy-img :lazy-src="user.profileImage" :alt="user.namaLengkap"
                              is-profile class="is-rounded" />
                  </a>
                </div>
                <div class="dropdown-menu">
                  <div class="dropdown-content" style="width: 160px">
                    <div class="dropdown-item">
                      <a @click="changePassword" class="has-icon"><span class="icon"><i
                        class="fas fa-user-lock"></i></span><span>Ubah Password</span></a>
                    </div>
                    <div class="dropdown-item">
                      <a @click="logout" class="has-icon"><span class="icon"><i
                        class="fas fa-sign-out"></i></span><span>Keluar</span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Container } from "annotation";
import Authentication from "../../Authentication";
import Store from "../../util/Store";
import UserService from "../../service/UserService";
import { useAuthStore } from "../../stores/auth.store";

import Menu from "../../entity/Menu";
import Configuration from "../../entity/Configuration";
import User from "../../entity/User";
import LazyImg from "./LazyImg.vue";
import Notification from "../../Notification";
import GModal from "./common/modal/GModal.vue";
import GButton from "./common/button/GButton.vue";
import GField from "./common/field/GField.vue";
import PenerimaSelect from "./input-auto-complete/PenerimaSelect.vue";
import NamaItemPembayaranSelect from "./input-auto-complete/NamaItemPembayaranSelect.vue";

@Component({
  components: { NamaItemPembayaranSelect, PenerimaSelect, GField, GButton, GModal, LazyImg }
})
export default class NavigationBar extends Vue {

  public get userService(): UserService {
    return Container.get(UserService);
  }

  @Prop({ type: Array, default: [] })
  public menus: Array<Menu>;

  @Prop({ type: String, default: "" })
  public roleName: string;

  @Prop({ type: Array, default: [] })
  public notifications: Array<Notification>;

  public isMenuActive: boolean = false;

  public menuSearch: string = "";

  public inputFocus: boolean = false;

  public modalPassword: boolean = false;

  public newPassword: string = "";

  public confirmPassword: string = "";

  public user: User = Authentication.getUser();

  public get linkProfileSetting() {
    return this.$route.fullPath;
  }

  public changePassword() {
    this.modalPassword = true;
  }

  public get settingApplication(): Configuration {
    return Store.getVmProperty("settingApplication.data", new Configuration());
  }

  public get menuSearchs() {
    const menus: Array<any> = this.menus.reduce((accu: Array<any>, item: Menu) => {
      const { childs, name, url } = item;

      if (childs.length > 0) {
        childs.forEach((child: any) => accu.push({ name: child.name, url: child.url }));
      } else {
        accu.push({ name, url });
      }

      return accu;
    }, []);

    let menusFilter: Array<any> = menus.filter((item: any) => item.name.toLowerCase()
      .includes(this.menuSearch.toLowerCase()));

    return menusFilter.length > 0 ? menusFilter : menus;
  }

  public onEnter() {
    const targetUrl: Menu = this.menuSearchs.find((item: Menu) => item.name === this.menuSearch);

    if (targetUrl && targetUrl.url) {
      this.$router.push(targetUrl.url);
    }
  }

  public onToggleFullScreen() {
    const app: any = document.getElementById("app");

    if (app.requestFullscreen) {
      app.requestFullscreen();
    } else if (app.webkitRequestFullscreen) {
      app.webkitRequestFullscreen();
    } else if (app.mozRequestFullScreen) {
      app.mozRequestFullScreen();
    } else if (app.msRequestFullscreen) {
      app.msRequestFullscreen();
    }
  }

  public logout() {
    const authStore = useAuthStore();
    authStore.logout();
  }

  public doChangePassword() {
    if (this.newPassword != this.confirmPassword) {
      Notification.showNotification({ text: "Password yang anda masukan tidak sama" }, true);
    } else {
      this.user.password = this.newPassword;
      this.user.confirmPassword = this.confirmPassword;

      this.userService.changePassword(this.user).then(() => {
        this.modalPassword = false;

        // Force logout when success
        this.logout();
      });
    }
  }

}
</script>

<style lang="scss">
@import "../../style/variables_function";

.navbar-main {
  height: 80px;

  > .container {
    padding: 0 1rem;
  }

  .navbar-brand {
    margin-right: 1rem;

    .nb-i-wrp {
      @include fl_row;
      align-items: center;

      .detail {
        p.title {
          margin-bottom: 0rem;
          color: $color-dark;
        }

        flex: 1;
      }

      img {
        max-height: none;
        width: auto;
        height: 45px;
        margin-right: 1rem;
      }
    }
  }

  .navbar-start {
    display: flex;
    align-items: center;

    .autocomplete {
      width: 300px;
      transition: .5s;

      &.is-focused {
        width: 375px;
      }
    }

    input {
      padding-left: 3em !important;

      & + span {
        margin-left: 6px;
      }
    }
  }

  .navbar-end {
    .navbar-item {
      transition: .25s;

      img {
        max-height: 1.75rem;
        width: auto;
      }

      &:hover {
        border-bottom: 3px solid $green;
      }
    }

    .dropdown-menu {
      padding: 1rem .75rem .75rem;
      margin-right: -1rem;

      .dropdown-item {
        padding: .5rem .75rem;

        &:hover {
          background-color: $grey-lighten;
        }

        &:not(:last-child) {
          border-bottom: 1px solid $grey-lighter;
        }

        a, a:hover {
          color: $grey-dark;
        }
      }
    }
  }

  .navbar-menu .navbar-end {
    a i {
      color: $color-text-mute;
    }

    img {
      border-radius: 50%;
    }
  }

  span.icon i {
    font-size: 1.25rem;
  }

  .is-notif-item {
    position: relative;

    .unread-notif {
      color: white;
      display: block;
      position: absolute;
      right: 0;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      top: .75rem;
      background: $danger;
    }


    .dropdown-content {
      width: 270px;
      padding: .75rem;
      overflow: auto;
      max-height: 300px;

      .media {
        & + .media {
          border-top: none;
          margin-top: .75rem;
          padding-top: .75rem;
        }

        .media-left {
          @include fl_row(flex-start, center);

          span.round {
            width: 11px;
            height: 11px;
            margin-right: .75rem;
            border-radius: 50%;
            background-color: $color-primary-young;
            display: block;
          }

          img {
            object-fit: cover;
            height: 32px;
            max-height: none;
            width: 32px;
          }
        }

        &.is-link {
          cursor: pointer;
        }
      }
    }
  }

  @media screen and (max-width: 1600px) {
    .container.is-widescreen {
      padding: 0 2.5rem;
    }
  }

  @media screen and (max-width: 1023px) {
    .navbar-end {
      display: flex;
    }

    .navbar-brand {
      height: 80px;
    }

    .navbar-menu {
      display: flex;

      .navbar-start {
        flex: 1;

        .navbar-item, .autocomplete {
          width: 100%;
        }
      }
    }

    .navbar-burger {
      height: 80px;
      width: 60px;

      span {
        width: 24px;
        left: calc(50% - 12px);
      }
    }
  }

  .modal-input-password {
    .head {
      background-color: $color-primary-young;

      p {
        color: $white;
      }
    }

    .columns {
      padding: .75rem 0;

      .column:first-child {
        padding-right: 1.25rem;
      }

      .column:last-child {
        padding-left: 1.25rem;
      }
    }
  }

}

</style>
